@if (changeDetection$ | async) {
  <ng-container [formGroup]="volymForm">
    <td>{{volymForm.controls.handelssortimentnamn.value}}</td>
    <td>{{volymForm.controls.mattslag.value}}</td>
    <td>
      <rask-input-number [useDecimalProcessor]="true"
        formControlName="kvantitet">
      </rask-input-number>
    </td>
  </ng-container>
}